<template>
  <div class="container-fluid">
    <!-- Estado de carga -->
    <div v-if="loading" class="text-center py-5">
      <div class="loader-box">
        <div class="loader-3"></div>
      </div>
      <p>Cargando...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="text-center py-5">
      <div class="alert alert-danger">
        <h5>Error al cargar los datos</h5>
        <p>{{ error.message || 'Ocurrió un error inesperado' }}</p>
        <button class="btn btn-primary" @click="fetchPosts()">Reintentar</button>
      </div>
    </div>

    <!-- Contenido cuando hay datos -->
    <div v-else-if="welcome != null">      
      
      <!-- Tarjetas con los documentos obtenidos del request -->
      <div class="row starter-main">

        <div class="col-sm-12 col-lg-12" v-for="post in welcome" :key="post.id">
          <div class="card mt-2">
            <div class="card-header p-1">            
              <img
                v-if="post.thumbnail_rendition"
                :src="post.thumbnail_rendition.full_url"
                :alt="post.thumbnail_rendition.alt"
                class="card-img-top"
                style="object-fit: contain; max-height: 80px; padding: 0.25rem;"
              />                         
            </div>
            <div class="card-body p-4">              
              <div class="post-body" v-html="post.body"></div>
            </div>
            <div class="card-footer p-4" v-if="post.footer">
              <p class="mb-0">Para mayor información <span v-html="post.footer"></span></p>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import api from "@/axios";

export default {
  name: "SobreNosotros",
  data() {
    return {
      welcome: null,
      error: null,
      loading: true,
    };
  },
  created() {
    this.fetchPosts();
  },
  methods: {
    async fetchPosts() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await api.get("blog?child_of=18&fields=intro,body,thumbnail,thumbnail_rendition,footer&order=first_published_at");
        this.welcome = data.items ?? (Array.isArray(data) ? data : [data]);
      } catch (err) {
        this.error = err;
        console.error("error en fetchPosts", err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>


